import { RouterModule, Routes } from '@angular/router';
import { LoginComponent } from './login/login.component';
import { NopagefoundComponent } from './shared/nopagefound/nopagefound.component';
import { RegisterComponent } from './login/register.component';
import { AsistenciaComponent } from './certificados/asistencia/asistencia.component';
import { TrabajoComponent } from './certificados/trabajo/trabajo.component';
import { CertificadoCursoComponent } from './certificados/certificado-curso/certificado-curso.component';
import { CertificadosSimposiosComponent } from './certificados/certificados-simposios/certificados-simposios.component';
import { CertificadoConferenciaComponent } from './certificados/certificado-conferencia/certificado-conferencia.component';
import { CertificadosTalleresComponent } from './certificados/certificados-talleres/certificados-talleres.component';
import { CertificadosMesasComponent } from './certificados/certificados-mesas/certificados-mesas.component';
import { RecuperarPasswordComponent } from './login/recuperar-password.component';
import { CertificadoPagoComponent } from './certificados/certificado-pago/certificado-pago.component';

const appRoutes: Routes = [
    {path: 'login', component: LoginComponent},
    {path: 'register', component: RegisterComponent},
    {path: 'recuperar-password', component: RecuperarPasswordComponent},
    {path: 'certificado-asistencia', component: AsistenciaComponent},
    {path: 'certificado-trabajo', component: TrabajoComponent},
    {path: 'certificado-curso/:curso', component: CertificadoCursoComponent},
    {path: 'certificado-simposio/:simposio', component: CertificadosSimposiosComponent},
    {path: 'certificado-taller/:taller', component: CertificadosTalleresComponent},
    {path: 'certificado-conferencia/:conferencia', component: CertificadoConferenciaComponent},
    {path: 'certificado-mesa/:mesa', component: CertificadosMesasComponent},
    {path: 'certificado-pago', component: CertificadoPagoComponent},
    {path: '**', component: NopagefoundComponent}
];

export const APP_ROUTES = RouterModule.forRoot( appRoutes, { useHash: true } );



// WEBPACK FOOTER //
// ./src/app/app.routes.ts